// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"2cb22a39","166":"c398a7ed","326":"08005a1e","679":"2fd263b4","787":"40368034","926":"a57dada1"}[chunkId] + ".chunk.js";
};